











import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import QueryCondition from '@/model/QueryCondition'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'
import 'moment/locale/zh-cn'

@Component
export default class QueryItem extends Vue {
  @Prop()
  private item!: QueryCondition

  private value: any = null
  private locale = locale

  private inputValueChanged (e: any) {
    this.emitValueChanged(this.item.name, e.data)
  }

  private dateRangeValueChanged (dates: any, dateStrings: any) {
    let strValue = ''
    if (dateStrings.length === 2 && dateStrings[0] && dateStrings[1]) {
      strValue = dateStrings[0] + '~' + dateStrings[1]
    } else {
      strValue = ''
    }
    this.emitValueChanged(this.item.name, strValue)
  }

  private selectValueChanged (val: string) {
    this.emitValueChanged(this.item.name, val)
  }

  @Emit('valueChanged')
  private emitValueChanged (name: string, value: string) {
    //
  }

}
